<template>
  <Row class="d-flex" v-size.height="'80vh'">
    <Col class="d-flex flex-column justify-center text-center">
      <Progress class="align-self-center" circular :value="10" :color="'primary'" :indeterminate=true :rotate="5" :size="80" :border-width="5"/>
      <h4 :class="titleClass" v-text="lc.title" />
      <span :class="subtitleClass" v-text="lc.subtitle" />
    </Col>
  </Row>
</template>

<script>
import Cookies from 'js-cookie'
import { Progress, Row, Col, useLocale, useNotification, useVueRouter } from '@locaweb/design-system-vue'
import { onMounted } from 'vue'
import { NOTIFICATION_DEFAULTS } from '@/consts'
import { useEditor } from '@/composables/api/useEditor'

export default {
  name: 'EditorView',
  components: {
    Progress,
    Row,
    Col
  },
  setup () {
    const { execute: executeFetch } = useEditor()
    const lc = useLocale('site.editor')
    const { $route } = useVueRouter()
    const notify = useNotification()
    const titleClass = 'text-h2 ubuntu font-weight-medium mt-6 mb-1'
    const subtitleClass = 'text-paragraph-1 ubuntu font-weight-regular'

    function onSuccess ({ editorUrl, accessToken, login, siteId, defaultDomain }) {
      const fullDomain = new URL(editorUrl).hostname.replace('www.', '')
      const domain = fullDomain.split('.').slice(1).join('.')

      const editorCookiesParams = { domain, expires: 0.25 }

      Cookies.set('editorUrl', editorUrl, editorCookiesParams)
      Cookies.set('accessToken', accessToken, editorCookiesParams)
      Cookies.set('login', login, editorCookiesParams)
      Cookies.set('siteId', siteId, editorCookiesParams)
      Cookies.set('defaultDomain', defaultDomain, editorCookiesParams)

      window.open(editorUrl, '_self')
    }

    function onError () {
      notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.error, state: 'error' })
    }

    onMounted(async () => await executeFetch({ id: $route.params.siteId, onSuccess, onError }))

    return { lc, titleClass, subtitleClass }
  }
}
</script>
